import { render, staticRenderFns } from "./TransferTab51.vue?vue&type=template&id=7e35767c&scoped=true"
import script from "./TransferTab51.vue?vue&type=script&lang=js"
export * from "./TransferTab51.vue?vue&type=script&lang=js"
import style0 from "./TransferTab51.vue?vue&type=style&index=0&id=7e35767c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e35767c",
  null
  
)

export default component.exports